import { LocalizationHelperInstance } from "utils/helpers";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { CommonEnums } from "models/enums";
import { RatingInfo } from "models/propTypes/commonPropTypes";

function useRatingService() {
  const getRatingInfo = (orgType: CommonEnums.OrganizationTypes, currentValue?: number | null): RatingInfo => {
    let ratingValue = 0;
    let displayType: StyleEnums.DisplayType;
    let ratingText: string;
    let displayText: string;

    if (currentValue === undefined) {
      displayType = StyleEnums.DisplayType.Info;
      ratingText = LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Rating.CreditRatingNoCompanySelectedText
      );
      displayText = TranslationKeys.Rating.HowHighRating;
    } else if (currentValue === null) {
      displayType = StyleEnums.DisplayType.None;
      ratingText = LocalizationHelperInstance.getFormattedMessage(`Rating.NoRatingFound_${orgType}`);
      displayText = TranslationKeys.Rating.NoRatingFoundShort;
    } else {
      ratingText = `${currentValue}`;
      ratingValue = currentValue / 20;
      if (currentValue >= 80) {
        displayType = StyleEnums.DisplayType.Success;
        displayText = `Rating.Great_${orgType}`;
      } else if (currentValue >= 60) {
        displayType = StyleEnums.DisplayType.Success;
        displayText = `Rating.Good_${orgType}`;
      } else if (currentValue >= 40) {
        displayType = StyleEnums.DisplayType.Success;
        displayText = `Rating.Ok_${orgType}`;
      } else if (currentValue >= 15) {
        displayType = StyleEnums.DisplayType.Warning;
        displayText = `Rating.NotSure_${orgType}`;
      } else if (currentValue >= 0) {
        displayType = StyleEnums.DisplayType.Danger;
        displayText = `Rating.Bad_${orgType}`;
      } else {
        ratingText = `?`;
        displayType = StyleEnums.DisplayType.None;
        displayText = `Rating.None_${orgType}`;
      }
    }

    return {
      ratingValue,
      ratingText,
      displayText: LocalizationHelperInstance.getFormattedMessage(displayText),
      displayType,
    };
  };

  return { getRatingInfo };
}

export default useRatingService;
